import api from "../helpers/axios";

class ModelService {

    async getLlmModels() {
        try {
            const url = `/models/available`;
            const models = await api.get(url);
            return models.data;
        } catch (error) {
            console.log("Error getLlmModels: ", error);
        }
    }

    // Superadmin-only — all GlobalModelConfig rows (unlike /models/available,
    // which is scoped to what's active/assignable). Used to pick exact config
    // rows for a model_deprecation notification's affected_models.
    async getGlobalModelConfigs() {
        try {
            const url = `/models/global`;
            const models = await api.get(url);
            return models.data;
        } catch (error) {
            console.log("Error getGlobalModelConfigs: ", error);
        }
    }

}

export default new ModelService();

